(function () {
  'use strict';

  const structures = {
    privacy: {
      count: 26,
      children: 40,
      headings: [
        'INTRODUCTION',
        'PERSONAL INFORMATION WE COLLECT WHEN YOU VISIT OUR WEBSITE',
        'PERSONAL INFORMATION WE COLLECT WHEN YOU MAKE A PURCHASE OR REGISTER FOR AN ACCOUNT',
        'HOW WE USE PERSONAL INFORMATION AND DEVICE INFORMATION',
        'SHARING YOUR PERSONAL INFORMATION AND DEVICE INFORMATION',
        'REMARKETING AND BEHAVIOURAL ADVERTISING',
        'DO NOT TRACK',
        'GDPR',
        'GENERAL TERMS',
      ],
      displayHeadings: [
        'Introduction',
        'Personal information we collect when you visit our website',
        'Personal information we collect when you make a purchase or register for an account',
        'How we use personal information and device information',
        'Sharing your personal information and device information',
        'Remarketing and behavioural advertising',
        'Do not track',
        'GDPR',
        'General terms',
      ],
    },
    terms: {
      count: 19,
      children: 32,
      headings: [
        'TERMS AND CONDITIONS OF BUSINESS',
        'ONLINE SHOPPING',
        'DELIVERY',
        'ORDER CANCELLATION',
        'LIABILITY AND INDEMNITY',
        'JURISDICTION',
        'ENTIRE AGREEMENT',
        'GENERAL',
      ],
      displayHeadings: [
        'Terms and conditions of business',
        'Online shopping',
        'Delivery',
        'Order cancellation',
        'Liability and indemnity',
        'Jurisdiction',
        'Entire agreement',
        'General',
      ],
    },
  };

  function normalizedText(value) {
    return value.replace(/\s+/g, ' ').trim();
  }

  function enhanceLegalPolicy(root) {
    const wrapper = root.querySelector('.bb-policy--privacy, .bb-policy--terms');
    const kind = wrapper?.classList.contains('bb-policy--privacy') ? 'privacy' : 'terms';
    const structure = structures[kind];
    const body = wrapper?.querySelector('.shopify-policy__body .rte');
    if (!body || body.dataset.bbLegalClauses === 'enhanced') return false;

    const children = Array.from(body.children);
    if (children.length !== structure.children || children.some((node) => node.tagName !== 'P')) return false;
    const parsed = [];
    let headingIndex = 0;
    let clauseNumber = 0;
    for (const node of children) {
      const text = normalizedText(node.textContent);
      if (text === structure.headings[headingIndex]) {
        parsed.push({ type: 'heading', node, index: headingIndex });
        headingIndex += 1;
        continue;
      }
      const match = text.match(/^(\d+)(?:\.)?\s/);
      if (match) {
        if (headingIndex === 0 || Number(match[1]) !== clauseNumber + 1 || node.firstChild?.nodeType !== 3) return false;
        clauseNumber += 1;
        parsed.push({ type: 'clause', node, number: clauseNumber });
        continue;
      }
      if (clauseNumber === 0) return false;
      parsed.push({ type: 'continuation', node });
    }
    if (headingIndex !== structure.headings.length || clauseNumber !== structure.count) return false;
    if (parsed.at(-1).type !== 'clause' && parsed.at(-1).type !== 'continuation') return false;

    let list;
    let copy;
    for (const part of parsed) {
      if (part.type === 'heading') {
        part.node.dataset.bbSourceHeading = normalizedText(part.node.textContent);
        part.node.textContent = structure.displayHeadings[part.index];
        part.node.classList.add('bb-policy__legal-heading');
        list = root.createElement('ol');
        list.className = 'bb-policy__clause-list';
        part.node.after(list);
      } else if (part.type === 'clause') {
        const item = root.createElement('li');
        item.className = 'bb-policy__clause';
        const marker = root.createElement('span');
        marker.className = 'bb-policy__clause-number';
        marker.setAttribute('aria-hidden', 'true');
        marker.textContent = String(part.number);
        copy = root.createElement('div');
        copy.className = 'bb-policy__clause-copy';
        const prefix = part.node.firstChild.textContent.match(new RegExp(`^${part.number}\\.?[\\s\\u00a0]+`))[0];
        part.node.firstChild.textContent = part.node.firstChild.textContent.slice(prefix.length);
        const original = root.createElement('span');
        original.className = 'bb-policy__original-number';
        original.setAttribute('aria-hidden', 'true');
        original.textContent = prefix;
        part.node.prepend(original);
        copy.appendChild(part.node);
        item.append(marker, copy);
        list.appendChild(item);
      } else {
        copy.appendChild(part.node);
      }
    }
    body.dataset.bbLegalClauses = 'enhanced';
    return true;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { enhanceLegalPolicy, normalizedText };
  }
  if (typeof document !== 'undefined') enhanceLegalPolicy(document);
})();
